import { configureStore } from "@reduxjs/toolkit";
import { auth, vendor, eventManager } from "./reducers";

export const store = configureStore({
    reducer: {
        auth,
        vendor,
        eventManager,
    },
});
